<sample-search-table></sample-search-table>

<pandora-aside [title]="'Search'" [isToggleAvailable]=true [isToggleButtonExists]=true [isAsideOpen]=true>
    <div aside-content><sample-search-sidebar></sample-search-sidebar></div>
</pandora-aside>
